import { createSelector } from 'reselect';
import { getMainVideoId } from '@wix/wix-vod-shared/dist/src/widget/ui-selectors/selected-video-id';
import { getVideosGroupedByIds } from '../../shared/selectors/videos';
export var getMainVideo = createSelector([getMainVideoId, getVideosGroupedByIds], function (mainVideoId, videoByIds) { return videoByIds[mainVideoId]; });
